import { render, staticRenderFns } from "./callbacksTableRow.vue?vue&type=template&id=0f8bf731"
import script from "./callbacksTableRow.vue?vue&type=script&lang=js"
export * from "./callbacksTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports